import { render, staticRenderFns } from "./DeliveryDetailsCard.vue?vue&type=template&id=b2a55c54"
import script from "./DeliveryDetailsCard.vue?vue&type=script&lang=ts"
export * from "./DeliveryDetailsCard.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports